export default "__VITE_ASSET__XqRVuf61__"